import { createUniComponentFromWebComponent } from '../../utils/uni-component/index.js';
import { DataViewHeaderViews } from './views.js';

export const widgetViewsBar =
  createUniComponentFromWebComponent(DataViewHeaderViews);
